import { render, staticRenderFns } from "./ActivityParksList.vue?vue&type=template&id=56da6f4d&"
import script from "./ActivityParksList.vue?vue&type=script&lang=js&"
export * from "./ActivityParksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports